/* eslint-disable quotes */
import { h } from 'vue';

const body = `<h4>Save cropped STL to file</h4>

<p>Save the reference STL model to file. If in section view, only the visible part will be saved. </p>`;

export default function SaveSTLTooltip() {
    return h('div', { innerHTML: body });
}
